// CircleBadge.jsx
import styles from "./index.module.css";

const CircleBadge = ({ value, type = "default" }) => {
  // Creamos las clases dinámicamente
  const containerClass = `${styles.container} ${type === "main" ? styles.mainContainer : ""}`;
  const valueClass = `${styles.value} ${type === "main" ? styles.mainValue : ""}`;

  return (
    <div className={containerClass}>
      <div className={valueClass}>{value}</div>
    </div>
  );
};

export default CircleBadge;
